import React from 'react';
import { observer } from 'mobx-react';
import { Fade } from '@material-ui/core';
import { useReportContext } from 'contexts/report/ReportContext';
import { FsComponentSize } from 'globals/types';
import { isSuccessState } from 'globals/utils';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import FsGridContainer from 'ui-elements/grid/FsGridContainer/FsGridContainer';
import FsGridItem from 'ui-elements/grid/FsGridItem/FsGridItem';
import CashflowSummaryItem from './CashflowSummaryItem';
import { ReportCashflowSummaryContainer } from './ReportCashflowSummarySection.style-elements';

const ReportCashflowSummarySection: React.FC = () => {
  const {
    report: {
      cashflowSummary: { status, rows },
    },
  } = useReportContext();
  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
      />
    );
  return (
    <Fade in={isSuccessState(status)} timeout={1000}>
      <FsGridContainer>
        <FsGridItem xs={12}>
          <FsPaper
            data-test="report-cashflow-summary-section-component"
            paddingSize={FsComponentSize.S}
            withContentMargin={false}
          >
            <ReportCashflowSummaryContainer>
              {rows().map(({ label, ...otherProps }) => (
                <CashflowSummaryItem
                  {...otherProps}
                  key={label}
                  label={label}
                />
              ))}
            </ReportCashflowSummaryContainer>
          </FsPaper>
        </FsGridItem>
      </FsGridContainer>
    </Fade>
  );
};

ReportCashflowSummarySection.displayName = 'ReportCashflowSummarySection';

export default observer(ReportCashflowSummarySection);
